import React from "react";
import { useTranslation } from "react-i18next";

import { CustomModalButtons } from "../../constants/global.constants";

import { combineClassNames } from "../../utils/appUtils";

import IconButton from "../../packages/IconButton";
import CloseIcon from "../../packages/SVGs/CloseIcon";
import WPButton from "../../packages/WPButton";
import WPTertiaryButton from "../../packages/WPTertiaryButton";
import WPHeading from "../../packages/WPHeading";
import WPLoader from "../../packages/WPLoader";

import { colors } from "../../common/styles/Theme";

import StyledCustomModal from "./StyledCustomModal";
import { RedoIcon } from "../../assets/icons";

const CustomModal = ({
  header,
  headerHelper,
  confirmBtn,
  confirmBtnDisabled,
  restoreDefaultsBtn,
  cancelBtn,
  children,
  onModalClose,
  customclass,
  custombodyclass,
  width,
  cancelBtnDisabled,
  isLoading,
  loadingText,
  cancelBtnType,
  confirmBtnType,
  size,
  invisible,
  modalFooter,
  hideCloseIcon,
  headerTooltip,
  headerClass = "",
  headerDataTestId,
  headerTooltipPlacement,
  hideFooter,
}) => {
  const { t } = useTranslation();
  const handleBtnClick = (id) => {
    if (onModalClose) {
      onModalClose({ target: { id } });
    }
  };

  return (
    <StyledCustomModal
      show
      centered
      className={combineClassNames(customclass, invisible && "invisible")}
      width={width}
      size={size}
      backdrop={!invisible}
      enforceFocus={false}
      scrollable
    >
      {isLoading && <WPLoader loadingMsg={loadingText} />}
      <StyledCustomModal.Header>
        <div
          className={headerClass}
          data-test-id={headerDataTestId || "wp-modal-header"}
        >
          <WPHeading
            size={size}
            tooltip={headerTooltip}
            tooltipPlacement={headerTooltipPlacement}
          >
            {header}
          </WPHeading>
          <WPHeading
            className="subHeading"
            size="small"
            secondary
            color={colors.blackTransparency045}
          >
            {headerHelper}
          </WPHeading>
        </div>
        {!hideCloseIcon && (
          <IconButton
            id="modal-close-icon"
            tooltip={t("CIPEvent.close")}
            onClick={() => handleBtnClick(CustomModalButtons.CLOSE)}
          >
            <CloseIcon />
          </IconButton>
        )}
      </StyledCustomModal.Header>
      <StyledCustomModal.Body>
        <div
          className={custombodyclass ? custombodyclass : "modal-body-container"}
        >
          {children}
        </div>
      </StyledCustomModal.Body>
      {!hideFooter && (
        <StyledCustomModal.Footer
          style={{
            justifyContent: "space-between",
          }}
        >
          <div>
            {restoreDefaultsBtn && (
              <WPTertiaryButton
                id={CustomModalButtons.RESTORE}
                icon={<RedoIcon />}
                label={restoreDefaultsBtn}
                onClick={() => handleBtnClick(CustomModalButtons.RESTORE)}
                iconPlacement="before"
                className="tertiary-btn-left"
              />
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {cancelBtn && (
              <WPButton
                type={cancelBtnType}
                variant="outlined"
                id={CustomModalButtons.CANCEL}
                onClick={() => handleBtnClick(CustomModalButtons.CANCEL)}
                disabled={cancelBtnDisabled}
              >
                {cancelBtn}
              </WPButton>
            )}
            {confirmBtn && (
              <WPButton
                type={confirmBtnType}
                disabled={confirmBtnDisabled}
                id={CustomModalButtons.CONFIRM}
                onClick={() => handleBtnClick(CustomModalButtons.CONFIRM)}
              >
                {confirmBtn}
              </WPButton>
            )}
          </div>
          {modalFooter}
        </StyledCustomModal.Footer>
      )}
    </StyledCustomModal>
  );
};

export default CustomModal;
